import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import DefaultContainer from '../../components/container/DefaultContainer'
import Header from '../../components/container/Header'
import MainNaviagation from '../../components/navigation/MainNaviagation'
import InnerNaviagation from '../../components/navigation/InnerNaviagation'
import Footer from '../../components/container/Footer'
import AboutContainer from '../../components/container/company/AboutContainer'
import HeaderTitle from '../../components/inner/HeaderTitle'

import backgroundImage from '../../assets/technologies/technologiesBackgroundImage.png'

import Eternal from './Eternal'
import Delfort from './Delfort'
import Siwoon from './Siwoon'
import Aibus from './Aiverse'
import Union from './Union'
import Potron from './Potron'

const Technologies = () => {

  const TechnologiesItem = ["Eternal", "Delfort", "Siwoon", "Aiverse", "Union Image", "Potron"];

    return (
        <DefaultContainer>
            <Header headerBackgroundImage={backgroundImage}>
                <MainNaviagation />
                    <HeaderTitle>Vendor & Product</HeaderTitle>
                <InnerNaviagation item={TechnologiesItem}/>
            </Header>

            <AboutContainer>
              <Routes>
                <Route path='/' element={<Navigate to="Eternal" replace={false}/> }/>
                <Route path='/Eternal' element={<Eternal/>} />
                <Route path='/Delfort' element={<Delfort/>} />
                <Route path='/Siwoon' element={<Siwoon/>} />
                <Route path='/Aiverse' element={<Aibus/>} />
                <Route path='/Union Image' element={<Union/>} />
                <Route path='/Potron' element={<Potron/>} />
              </Routes>
            </AboutContainer>
    
            <Footer />
    
        </DefaultContainer>
      )
}


export default Technologies